import { render } from "./PaisesVenta.vue?vue&type=template&id=380f3b1c&scoped=true"
import script from "./PaisesVenta.vue?vue&type=script&lang=js"
export * from "./PaisesVenta.vue?vue&type=script&lang=js"

import "./PaisesVenta.vue?vue&type=style&index=0&id=380f3b1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380f3b1c"]])

export default __exports__